import React, { useState } from 'react';
import IconButton from '@mui/material/IconButton';
import InstantFeedbackModalForm from './InstantFeedbackForm';
import { useAuthorization } from 'framework/authorization';
import { FeedbackIcon, Tooltip } from 'framework/ui/mui-builder';

const InstantFeedbackButton = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const { isGranted } = useAuthorization();
  const hasPermissions = isGranted('EMPLOYEE_FEEDBACK_CREATE_INSTANT_FEEDBACK_FE');

  const openFeedbackForm = () => setIsFormOpen(true);

  const closeFeedbackForm = () => setIsFormOpen(false);

  if (!hasPermissions) {
    return null;
  }

  return (
    <>
      <IconButton onClick={openFeedbackForm}>
        <Tooltip title="Leave feedback for colleague">
          <span style={{ display: 'inline-flex' }}>
            <FeedbackIcon fontSize="medium" />
          </span>
        </Tooltip>
      </IconButton>
      {isFormOpen && <InstantFeedbackModalForm closeFeedbackForm={closeFeedbackForm} />}
    </>
  );
};

export default InstantFeedbackButton;
